import React, { FC } from 'react'

const UseTerms: FC = () => {
  return (
    <object
      style={{ minWidth: '100vw', minHeight: '100vh' }}
      aria-label="pdf"
      type="application/pdf"
      data="/files/use-terms.pdf"
    />
  )
}

export default UseTerms
